// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"PromoTagEditor_fullWidth__5FuZG","promoTag":"PromoTagEditor_promoTag__3Pe9y","preview":"PromoTagEditor_preview__2e6Mx"};